/* eslint-disable no-unused-vars */
import { firebase, firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const setUserInfo = async (authUser) => {
	// remove any functions that might be on the authUser
	const userInfoToStore = JSON.parse(JSON.stringify(authUser))
	const uid = userInfoToStore && userInfoToStore.user ? userInfoToStore.user.uid : null
	if (uid) {
		const userInfo = {
			...userInfoToStore,
			uid,
			modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp()
		}
		try {
			await firestore.collection('userInfo').doc(uid).set(userInfo)
			return { userInfo }
		} catch (exception) {
			throw errorOfType(errorTypes.UNKNOWNERROR, uid, exception)
		}
	}
	throw errorOfType(errorTypes.KEYNOTSPECIFIED, `No User ID in user: ${JSON.stringify(userInfoToStore, null, 4)}`)
}

export default setUserInfo



// WEBPACK FOOTER //
// ./src/dataservices/setUserInfo.js